const Colors = {}

const _random = (min, max) => Math.random() * (max - min + 1) + min

export const rgbToHex = rgb =>
  `#${rgb
    .map(x => {
      const hex = Math.round(x).toString(16)
      return hex.length == 1 ? '0' + hex : hex
    })
    .join('')}`

export const hexToRgb = hex => {
  const _hex = hex.replace(/#/, '')

  if (3 == _hex.length) {
    return [
      parseInt(_hex.slice(0, 1) + _hex.slice(1, 2), 16),
      parseInt(_hex.slice(1, 2) + _hex.slice(2, 3), 16),
      parseInt(_hex.slice(2, 3) + _hex.slice(0, 1), 16)
    ]
  } else if (6 == _hex.length) {
    return [parseInt(_hex.slice(0, 2), 16), parseInt(_hex.slice(2, 4), 16), parseInt(_hex.slice(4, 6), 16)]
  } else {
    return [0, 0, 0]
  }
}
Colors.rgbToHex = rgbToHex
Colors.hexToRgb = hexToRgb

export const rgbToHsl = (r, g, b) => {
  const max = Math.max(r, g, b) / 255
  const min = Math.min(r, g, b) / 255

  let h = 0
  let s = 0
  const l = (max + min) / 2

  if (max != min) {
    const d = max - min

    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    if (max == r / 255 && g >= b) {
      h = (1.0472 * (g - b)) / 255 / d
    } else if (max == r / 255 && g < b) {
      h = (1.0472 * (g - b)) / 255 / d + 6.2832
    } else if (max == g / 255) {
      h = (1.0472 * (b - r)) / 255 / d + 2.0944
    } else if (max == b / 255) {
      h = (1.0472 * (r - g)) / 255 / d + 4.1888
    }

    h = h / 6.2832
  }

  return [360 * h, 100 * s, 100 * l]
}
export const hslToRgb = (h, s, l) => {
  let r = l / 100
  let g = l / 100
  let b = l / 100

  if (0 != s) {
    const hue2rgb = (p, q, t) => {
      let _t = t
      if (_t < 0) _t += 1
      if (_t > 1) _t -= 1
      if (_t < 1 / 6) return p + (q - p) * 6 * _t
      if (_t < 1 / 2) return q
      if (_t < 2 / 3) return p + (q - p) * (2 / 3 - _t) * 6
      return p
    }

    const q = l / 100 < 0.5 ? (l * (1 + s / 100)) / 100 : (l + s) / 100 - (l * s) / 10000
    const p = (2 * l) / 100 - q

    r = hue2rgb(p, q, h / 360 + 1 / 3)
    g = hue2rgb(p, q, h / 360)
    b = hue2rgb(p, q, h / 360 - 1 / 3)
  }
  return [255 * r, 255 * g, 255 * b]
}
Colors.rgbToHsl = rgbToHsl
Colors.hslToRgb = hslToRgb

export const hexToHsl = hex => {
  const rgb = hexToRgb(hex)
  return rgbToHsl(rgb[0], rgb[1], rgb[2])
}
export const hslToHex = hsl => rgbToHex(hslToRgb(hsl[0], hsl[1], hsl[2]))
Colors.hexToHsl = hexToHsl
Colors.hslToHex = hslToHex

export const hexToRgba = (hex, a) => {
  const _a = 'undefined' == typeof a || null === a ? 1 : Math.max(Math.min(a, 1), 0)
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5), 16)
  return `rgba(${r}, ${g}, ${b}, ${_a})`
}
Colors.hexToRgba = hexToRgba

export const colorsBlend = (c1, c2, pr) => {
  const r1 = Number('0x' + c1[1] + c1[2])
  const r2 = Number('0x' + c2[1] + c2[2])
  const g1 = Number('0x' + c1[3] + c1[4])
  const g2 = Number('0x' + c2[3] + c2[4])
  const b1 = Number('0x' + c1[5] + c1[6])
  const b2 = Number('0x' + c2[5] + c2[6])

  const r = parseInt(r1 - (r1 - r2) * pr, 10)
  const g = parseInt(g1 - (g1 - g2) * pr, 10)
  const b = parseInt(b1 - (b1 - b2) * pr, 10)

  return rgbToHex([r, g, b])
}
Colors.colorsBlend = colorsBlend

// The colour themes a report offers: eight palettes of 21, the first seven of each being the
// series colours. The colour-options panel lets the user pick one; a word-cloud preset names one
// by number (`colorsIndex`) and reads the same first seven.
export const COLOR_THEMES = [
  [
    '#8CC63F',
    '#60AC66',
    '#419982',
    '#1D83A2',
    '#1868A6',
    '#135182',
    '#003863',
    '#a9d46f',
    '#9bd49f',
    '#71b3a1',
    '#56a2b9',
    '#528ebc',
    '#4e7da1',
    '#406a8a',
    '#c6e39f',
    '#bce2bf',
    '#a0ccc1',
    '#8ec1d1',
    '#8cb4d3',
    '#89a8c1',
    '#809cb1'
  ],
  [
    '#FCD921',
    '#FBB03B',
    '#F7931E',
    '#F15A24',
    '#ED1C24',
    '#C1272D',
    '#6E272D',
    '#fde359',
    '#fcc46c',
    '#f9ae56',
    '#f5835b',
    '#f2555b',
    '#d15d62',
    '#925d62',
    '#feec90',
    '#fdd89d',
    '#fbc98f',
    '#f8ad92',
    '#f68e92',
    '#e09396',
    '#b79396'
  ],
  [
    '#C69C6D',
    '#A67C52',
    '#8C6239',
    '#754C24',
    '#603813',
    '#42210B',
    '#210F03',
    '#d4b592',
    '#bc9d7d',
    '#a9896b',
    '#98795b',
    '#886a4e',
    '#715948',
    '#594b42',
    '#e3ceb6',
    '#d3bea9',
    '#c6b19c',
    '#baa692',
    '#b09c89',
    '#a19085',
    '#908781'
  ],
  [
    '#CCCCCC',
    '#B2B2B2',
    '#999999',
    '#808080',
    '#666666',
    '#4D4D4D',
    '#333333',
    '#d9d9d9',
    '#c5c5c5',
    '#b3b3b3',
    '#a0a0a0',
    '#8c8c8c',
    '#7a7a7a',
    '#666666',
    '#e6e6e6',
    '#d9d9d9',
    '#cccccc',
    '#c0c0c0',
    '#b3b3b3',
    '#a6a6a6',
    '#999999'
  ],
  [
    '#CCCCCC',
    '#FBB03B',
    '#999999',
    '#8CC63F',
    '#666666',
    '#29ABE2',
    '#333333',
    '#ececec',
    '#fcc46c',
    '#b3b3b3',
    '#a9d46f',
    '#8c8c8c',
    '#5fc0e9',
    '#666666',
    '#f2f2f2',
    '#fdd89d',
    '#cccccc',
    '#c6e39f',
    '#b3b3b3',
    '#94d5f1',
    '#999999'
  ],
  [
    '#ED1C24',
    '#F7931E',
    '#FCD821',
    '#8CC63F',
    '#29ABE2',
    '#0071BC',
    '#9E005D',
    '#f2555b',
    '#f9ae56',
    '#fde259',
    '#a9d46f',
    '#5fc0e9',
    '#4095cd',
    '#b64086',
    '#f68e92',
    '#fbc98f',
    '#feec90',
    '#c6e39f',
    '#94d5f1',
    '#80b8de',
    '#cf80ae'
  ],
  [
    '#FF0066',
    '#FF80B3',
    '#FFE6F0',
    '#E0E0E0',
    '#808080',
    '#404040',
    '#000000',
    '#F25E96',
    '#F5A6C9',
    '#FCECF3',
    '#E9E9E9',
    '#A6A6A6',
    '#7A7A7A',
    '#656363',
    '#F68CB4',
    '#F8C0D8',
    '#FDF2F7',
    '#F0F0F0',
    '#C0C0C0',
    '#A0A0A0',
    '#918F90'
  ],
  [
    '#F58000',
    '#FFC700',
    '#D75426',
    '#B73F7C',
    '#551B57',
    '#76C5E4',
    '#145A7B',
    '#F59731',
    '#FFD233',
    '#D77451',
    '#B75185',
    '#552757',
    '#83ABBB',
    '#30637B',
    '#F5AF62',
    '#FFDD66',
    '#D7947C',
    '#B7648E',
    '#563857',
    '#778E97',
    '#496B7B'
  ]
]
Colors.COLOR_THEMES = COLOR_THEMES

// Heat scale shared by the stat gradients, red through green.
export const COLOR_GRADIENTS = {
  percents: [15, 30, 45, 60, 75, 99],
  colors: ['#C1272D', '#F15A24', '#F7931E', '#FCD821', '#D9E021', '#8CC63F']
}
Colors.COLOR_GRADIENTS = COLOR_GRADIENTS

// Picks the colour for `value` on a scale spread evenly across `min`..`max`, blending between
// the two neighbouring stops. Equivalent to the piecewise-linear scale the legacy page model
// builds, minus its memo cache.
//
// Degenerate and out-of-range inputs are resolved rather than left to produce an invalid
// colour: a zero-width range collapses to the top stop, and values outside the range clamp to
// the nearest end.
export const calcGradientColor = (min, max, value, colors = COLOR_GRADIENTS.colors) => {
  if (!Number.isFinite(value)) return colors[0]
  if (!Number.isFinite(min) || !Number.isFinite(max) || min === max) return colors[colors.length - 1]

  const step = (max - min) / (colors.length - 1)
  const offset = Math.max(Math.min((value - min) / step, colors.length - 1), 0)
  const index = Math.min(Math.floor(offset), colors.length - 2)

  return colorsBlend(colors[index], colors[index + 1], offset - index)
}
Colors.calcGradientColor = calcGradientColor

export const calcGradientColors = (colorStart, colorEnd, colorCount) => {
  const l = colorCount - 1
  const start = hexToRgb(colorStart)
  const end = hexToRgb(colorEnd)

  const saida = []
  for (let i = 0; i <= l; i++) {
    const c = [
      (i * end[0]) / l + (1 - i / l) * start[0],
      (i * end[1]) / l + (1 - i / l) * start[1],
      (i * end[2]) / l + (1 - i / l) * start[2]
    ]
    saida.push(rgbToHex(c))
  }
  return saida
}
Colors.calcGradientColors = calcGradientColors

export const transformHex = (hex, matrix) => {
  if (!hex) return null

  const hsl = hexToHsl(hex)

  return hslToHex([hsl[0] + matrix[0], hsl[1] + matrix[1], hsl[2] + matrix[2]])
}
Colors.transformHex = transformHex

export const randomHex = (hex, d = 1, type = 'random') => {
  if (null !== hex) {
    const hsl = hexToHsl(hex)

    const matrix = [_random(-5, 5), _random(hsl[1] / d, (hsl[1] - 100) / d), _random(hsl[2] / d, (hsl[2] - 100) / d)]

    return hslToHex([hsl[0] + matrix[0], hsl[1] - matrix[1], hsl[2] - matrix[2]])
  }

  let sMin = 10
  let sMax = 90
  let lMin = 10
  let lMax = 90

  switch (type) {
    case 'bright': {
      sMin = 55
      break
    }
    case 'light': {
      sMax = 55
      lMin = (lMax + lMin) / 2
      break
    }
    case 'dark': {
      sMin = sMax - 30
      lMax = lMin + 30
      break
    }
    default: {
      sMin = 20
      sMax = 80
      lMin = 25
      lMax = 75
      break
    }
  }

  return hslToHex([_random(0, 360), _random(sMin, sMax), _random(lMin, lMax)])
}
Colors.randomHex = randomHex

const harmonizedParams = {
  complementary: { start: 180, end: 180, step: 1 },
  split_complementary: { start: 150, end: 210, step: 60 },
  triadic: { start: 120, end: 240, step: 120 },
  tetradic: { start: 90, end: 270, step: 90 },
  analogous: { start: 30, end: 90, step: 30 },
  analogous_hue: { start: 7, end: 35, step: 7 },
  analogous_random: { start: 30, end: 90, step: 30 }
}

const RANDOM_METHODS = [
  'complementary',
  'split_complementary',
  'triadic',
  'tetradic',
  'analogous_hue',
  'analogous_random'
]
const RANDOM_METHODS_D = [1.4, 1.4, 1.6, 1.6, 10, 2]

export const harmonized = (hex, method, reverse = false) => {
  if (!hex) return []

  const hsl = hexToHsl(hex)
  const { start, end, step } = harmonizedParams[method]

  const colors = []
  const index = RANDOM_METHODS.indexOf(method)
  for (let i = start; i <= end; i += step) {
    const color = hslToHex([(hsl[0] + (reverse ? -1 : 1) * i + 360) % 360, hsl[1], hsl[2]])
    colors.push(-1 < index ? randomHex(color, RANDOM_METHODS_D[index]) : color)
  }
  return colors
}
Colors.harmonized = harmonized

export const complementary = (hex, reverse = false) => {
  const r = Math.floor(3 * Math.random()) + 1
  const colors = [hex]
  while (r > colors.length) {
    const color = colors[colors.length - 1]
    colors.push(randomHex(color, 1.3))
  }
  return harmonized(colors[colors.length - 1], 'complementary', reverse)
}
Colors.complementary = complementary

export const monochromatic = (hex, d = 1, reverse = false) => {
  if (!hex) return null

  const hsl = hexToHsl(hex)
  const matrix = [
    _random(-5, 5),
    0,
    reverse ? _random((hsl[2] - 100) / d, (hsl[2] - 100) / (2 * d)) : _random(hsl[2] / (2 * d), hsl[2] / d)
  ]

  return hslToHex([(hsl[0] - matrix[0] + 360) % 360, hsl[1], Math.max(0, hsl[2] - matrix[2])])
}
Colors.monochromatic = monochromatic

const randomTypes = ['bright', 'light', 'dark', 'random']

export const calculate = (hex, method, total, reverse = false) => {
  let colors = 'random' == method ? [] : [hex]
  const randomTypesIndex = 'random' == method ? Math.floor(randomTypes.length * Math.random()) : -1
  while (total > colors.length) {
    if ('random' == method) {
      colors.push(randomHex(null, null, randomTypes[randomTypesIndex]))
    } else {
      const color = colors[colors.length - 1]
      switch (method) {
        case 'monochromatic':
          colors.push(monochromatic(color, 1.7 * total - colors.length, reverse))
          break
        case 'complementary':
          colors = [...colors, ...complementary(color, reverse)]
          break
        default:
          colors = [...colors, ...harmonized(color, method, reverse)]
          break
      }
    }
  }
  return colors.splice(0, total)
}
Colors.calculate = calculate

export default Colors
